import { render, staticRenderFns } from "./BlogHomeEight.vue?vue&type=template&id=10797426"
import script from "./BlogHomeEight.vue?vue&type=script&lang=js"
export * from "./BlogHomeEight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports